import React from "react"
import { CenteredLoader } from "@humanpredictiveintelligence/myqvt-library"
import { t } from "ttag"

import * as Styles from "./LazyQuestionChoices.styles"

import { useGetChoicesOfQuestionLazyQuery } from "graphql/queries/generated/QuestionWithChoices"

export const LazyQuestionChoices: React.FC<LazyQuestionChoicesProps> = (props) => {
  const [ getChoicesByQuestionId, { data, loading: areChoicesLoading } ] = useGetChoicesOfQuestionLazyQuery()
  const questionChoices = data?.getQuestion.choices

  return (
    <Styles.Choices
      className={props.className}
      invite={t`Answers`}
      isOpen={props.isOpen}
      onClose={props.onClose}
      onOpen={() => onChoicesOpen()}
    >
      {renderContent()}
    </Styles.Choices>
  )

  function renderContent(): React.ReactNode {
    if (!areChoicesLoading && !questionChoices) {
      return (
        <Styles.Error>
          {t`An error occurred while retrieving the possible answers for this question.`}
        </Styles.Error>
      )
    }

    if (areChoicesLoading || !questionChoices) {
      return (
        <Styles.LoaderContainer>
          <CenteredLoader size="s" isTransparent/>
        </Styles.LoaderContainer>
      )
    }

    return questionChoices.map((choice) => (
      <Styles.Choice key={choice.id}>
        {choice.name}
      </Styles.Choice>
    ))
  }

  async function onChoicesOpen(): Promise<void> {
    props.onOpen?.()
    await getChoicesByQuestionId({ variables: { id: props.questionId } })
  }
}

interface LazyQuestionChoicesProps {
  questionId: number,
  isOpen?: boolean,
  onOpen?: () => void,
  onClose?: () => void,
  className?: string,
}
